import _ from 'lodash'
import { EntityState } from '@reduxjs/toolkit'
import { CommonState, Model } from '@/core/classes/Model'
import { SearchRequest } from '@/core/types/request'

export type CreateSpecialityOptionDto = {
  code: string
  name: string
  selectByDefault?: boolean
}

export type UpdateSpecialityOptionDto = Partial<CreateSpecialityOptionDto>

export type SpecialityOption = {
  _id: string
  code: string
  name: string
  selectByDefault?: boolean
}

export type SpecialityOptionState = CommonState & {
  specialityOptions: EntityState<SpecialityOption, SpecialityOption['_id']>
}

class SpecialityOptionModel extends Model {
  static instance: SpecialityOptionModel

  static getInstance() {
    if (!SpecialityOptionModel.instance) {
      SpecialityOptionModel.instance = new SpecialityOptionModel('specialityOption')
    }
    return SpecialityOptionModel.instance
  }

  getInitialState(): SpecialityOptionState {
    return _.merge({}, this.commonState, {
      specialityOptions: {
        entities: {},
        ids: [],
      },
    })
  }

  createSpecialityOption = async (createSpecialityOptionDto: CreateSpecialityOptionDto) => {
    return await this.httpClient.request<SpecialityOption>('/speciality-options', 'POST', createSpecialityOptionDto)
  }

  deleteSpecialityOption = async (specialityOptionId: string) => {
    return await this.httpClient.request<SpecialityOption>(`/speciality-options/${specialityOptionId}`, 'DELETE')
  }

  getSpecialityOptions = async (params?: SearchRequest) => {
    return await this.httpClient.request<SpecialityOption[]>('/speciality-options', 'GET', params)
  }

  updateSpecialityOption = async (specialityOptionId: string, updateSpecialityOptionDto: UpdateSpecialityOptionDto) => {
    return await this.httpClient.request<SpecialityOption>(`/speciality-options/${specialityOptionId}`, 'PATCH', updateSpecialityOptionDto)
  }
}

export default SpecialityOptionModel.getInstance()
